
<div class="form__group--border py-16 pb-32">
  <div aria-hidden="true" class="form__label pb-16">Set the rates for the services you provide</div>
  <ul>
    <li v-for="serviceRate in serviceRates" :key="serviceRate.service">
      <ServiceRatesInput
        ref="childComponents"
        :serviceRate="serviceRate"
        @input="updateRate"
        @serviceSelected="selectService"
      />
    </li>
  </ul>
  <HelperText v-if="!formStatuses.serviceRates" class="!-mt-16" :status="helperStatus.Error" :text="helperText" />
</div>
